export enum ERiskSolutions {
  fullExposure = "fullexposure",
  vip = "autopilot",
}

export enum ERiskSolutionLabels {
  fullexposure = "Full Exposure",
  autopilot = "AI Autopilot",
}

export enum ERoboRiskSolutionsLabels {
  "AUTO-PILOT" = "AI Autopilot",
  "FULL-EXPOSURE" = "Full Exposure",
}
/**
 * list of available risk solutions and their description
 * they're hardcoded values and should be removed
 */
export const RiskSolutions = {
  Retail: [
    {
      id: ERiskSolutions.vip,
      name: ERiskSolutionLabels.autopilot,
      description:
        "Automated personalized rebalancing, to remain in line with your risk profile.",
    },
  ],
  Professional: [
    {
      id: ERiskSolutions.fullExposure,
      name: ERiskSolutionLabels.fullexposure,
      description:
        "No personalized rebalancing, following the target market performance.",
    },
    {
      id: ERiskSolutions.vip,
      name: ERiskSolutionLabels.autopilot,
      description:
        "Automated personalized rebalancing, to remain in line with your risk profile.",
    },
  ],
};

// export enum RiskSolutionNameToId {
//   "Full Exposure" = ERiskSolutions.fullExposure,
//   "AI Autopilot" = ERiskSolutions.vip,
// }

export enum EType {
  TPREMIUM = "premium",
  TVIP = "vip",
}

// export const PremiumType = {
//   "AI Autopilot": "VIP",
//   "Full Exposure": "thematic",
//   personalized: "standard",
// };

export const Layers = {
  LBASE: "Diversified",
  LOPPURTUNISTIC: "Opportunistic",
  LTHEMATIC: "Thematic",
  LALL: "All",
};

export const FinamazeBank = {
  USA: "USA - Signature Bank New York",
  UAE: "UAE - unknown",
};

/**
 * Investment type
 * @deprecated
 */
export const TypeByRiskSolution = {
  [ERiskSolutions.fullExposure]: "premium",
  [ERiskSolutions.vip]: "vip",
  // [ERiskSolutions.personalized]: "standard",
};

/**
 * The markets that are NOT public.
 *
 * Two names, and three files were each testing for them with their own
 * string literal: the analytics page's Invest button, the private page's
 * Invest button, and the routing that decides which page a smartfolio has.
 * A market added or renamed in the backoffice would have had to be found in
 * all three.
 */
export const PRIVATE_MARKETS = ["Private Equity", "Structured Notes"];

export const isPrivateMarket = (market?: string) =>
  !!market && PRIVATE_MARKETS.includes(market);

/**
 * The allocation a risk profile suggests for a layer, as a percentage.
 *
 * FRONT-END CONSTANTS, and the service publishes nothing equivalent: the
 * report these figures sit beside, `/dashboard/reports/assets`, carries the
 * NAV and the percentage a client actually holds per layer and no suggestion
 * at all. So the product states a figure derived from a client's risk score
 * against a table maintained here. See the note in DESIGN.md.
 *
 * The table and the score bands were already in the app, in the invest
 * page's own utils, and are moved here because two pages read them and
 * because policy of this kind belongs with the product's other vocabulary
 * rather than in one screen's helpers.
 */
export const SUGGESTED_ALLOCATION: Record<
  string,
  { prudent: number; moderate: number; risky: number }
> = {
  [Layers.LBASE]: { prudent: 65, moderate: 50, risky: 34 },
  [Layers.LTHEMATIC]: { prudent: 25, moderate: 33, risky: 33 },
  [Layers.LOPPURTUNISTIC]: { prudent: 10, moderate: 17, risky: 33 },
};

/** Where a total assessment score puts a client. */
export const riskAppetite = (score?: number | string) => {
  const total = Number(score) || 0;
  if (total < 400) return "prudent" as const;
  if (total < 750) return "moderate" as const;
  return "risky" as const;
};

/**
 * The suggested percentage for a layer, or undefined when there is none.
 *
 * Undefined rather than zero on purpose: a layer this table says nothing
 * about is not a layer a client is advised to hold none of, and the two
 * would print identically.
 */
export const suggestedAllocation = (layer?: string, score?: number | string) =>
  layer ? SUGGESTED_ALLOCATION[layer]?.[riskAppetite(score)] : undefined;
